<template>
    <!-- 资源列表 -->
    <div class="resource-list" ref="resourceListRef">
        <template v-if="pageObj?.total">
            <div class="resource-list-wrapper">
                <div v-for="i in resourceList" :key="i.id" class="list-item">
                    <div :class="['list-item-top', { 'folder-item-top': i.fileType === 1 }]">
                        <div class="check-icon-name">
                            <el-checkbox
                                v-model="i.checked"
                                class="list-checkbox"
                                @change="listCheckChange($event, i)"
                                v-if="i.folderType !== 'system_default'"
                            ></el-checkbox>
                            <i
                                v-if="i.fileType === 1"
                                :class="['resource-font-icon', 'iconfont', 'icon-wenjianjia']"
                            ></i>
                            <img
                                v-else
                                class="resource-icon"
                                :src="fileType(i.firstMaterialType)"
                                alt=""
                            />
                            <p class="resource-name" @click="resourceClick(i)">
                                <ellipsis
                                    :content="i.fileName"
                                    :width="i.fileType === 1 ? '580px' : '606px'"
                                />
                            </p>
                        </div>
                        <el-popover
                            v-if="i.fileType === 1 && i.folderType !== 'system_default'"
                            class="drop-con"
                            placement="bottom-end"
                            trigger="click"
                            width="74px"
                            popper-class="folder-popover"
                            :show-arrow="false"
                            :offset="0"
                        >
                            <template #reference>
                                <i class="iconfont icon-gengduo1 resource-more-btn"></i>
                            </template>
                            <ul class="folder-popover-list">
                                <li
                                    v-for="(item, itemIdx) in folderBtnList"
                                    :key="itemIdx"
                                    @click="handleCommand(item.code, i)"
                                >
                                    {{ item.label }}
                                </li>
                            </ul>
                        </el-popover>
                    </div>
                    <!-- 文件夹的type为1 资源的是0 -->
                    <div class="list-item-bottom" v-if="i.fileType === 0">
                        <div class="resource-date-creator">
                            <p class="w146">
                                {{ `资源大小：${i.sizeFormat || '-'}` }}
                            </p>
                            <el-tooltip
                                v-if="i.categoryCode && i.categoryCode.split(',').length > 1"
                                class="box-item"
                                effect="dark"
                                popper-class="ellipsisTooltip"
                                placement="bottom"
                                :content="i.categoryShowList?.join('、')"
                            >
                                <p class="text-overflow w140">
                                    {{ `类型：${getCateTxt(i.categoryShowList)}` }}
                                </p>
                            </el-tooltip>
                            <p v-else class="text-overflow w140">
                                {{ `类型：${getCateTxt(i.categoryShowList)}` }}
                            </p>
                            <p>
                                {{ `公开范围：${valueFormate(i.openScope, scopeList) || '-'}` }}
                            </p>
                            <p>来源：{{ i.sourceName }}</p>
                            <p v-if="i.approveStatus" class="w146">
                                <span>{{
                                    `状态：${valueFormate(i.approveStatus, statusList)}`
                                }}</span>
                                <el-popover
                                    v-if="i.approveMessage && i.approveMessage !== ''"
                                    trigger="hover"
                                    popper-class="msg-popover"
                                    :content="explain(i.approveStatus, i.approveMessage)"
                                >
                                    <template #reference>
                                        <i class="iconfont icon-shuoming approve-msg"></i>
                                    </template>
                                </el-popover>
                            </p>
                            <el-tooltip
                                v-if="i.authors?.length"
                                class="box-item"
                                effect="dark"
                                popper-class="ellipsisTooltip"
                                placement="top"
                            >
                                <template #content>
                                    <p v-for="(item, index) in i.authors || []" :key="index">
                                        {{ item.userName }}
                                        {{ item.schoolName ? `-${item.schoolName}` : '' }}
                                    </p>
                                </template>
                                <p class="text-overflow w146">
                                    {{ `原作者：${fmtAuthors(i.authors)}` }}
                                </p>
                            </el-tooltip>
                            <p>
                                {{ `上传时间：${dateFormate(i.gmtCreate) || '-'}` }}
                            </p>
                            <p>
                                转码状态：{{
                                    i.materialStatusName === '可用'
                                        ? '转码成功'
                                        : i.materialStatusName
                                }}
                            </p>
                        </div>
                        <div class="resource-btn-con">
                            <template
                                v-for="(btn, btnIdx) in resourceBtnList"
                                :key="`resource_${i.id}_${btnIdx}`"
                            >
                                <el-button
                                    v-if="btn.show ? btn.show(i.approveStatus) : true"
                                    class="srt-el-button srt-el-button--link srt-el-button-h32"
                                    type="primary"
                                    @click="resourceItemClick(btn.code, i)"
                                    >{{ btn.label }}</el-button
                                >
                            </template>
                            <!-- </template> -->
                            <el-popover
                                class="drop-con"
                                placement="bottom-end"
                                trigger="click"
                                popper-class="folder-popover"
                                :show-arrow="false"
                                :offset="0"
                            >
                                <template #reference>
                                    <!-- <img class="resource-more-btn" v-if="idx % 2 === 0" src="@/assets/img/resource/more.png" alt=""> -->
                                    <i class="iconfont icon-gengduo1 resource-more-btn"></i>
                                </template>
                                <ul class="folder-popover-list">
                                    <template
                                        v-for="(item, itemIdx) in resourceMoreBtnList"
                                        :key="itemIdx"
                                    >
                                        <li
                                            v-if="item.show ? item.show(i.approveStatus) : true"
                                            @click="handleCommand(item.code, i)"
                                        >
                                            {{ item.label }}
                                        </li>
                                    </template>
                                </ul>
                            </el-popover>
                        </div>
                    </div>
                </div>
                <div class="page-con">
                    <Pagination
                        :currentPage="pageObj.pageIndex"
                        :page-size="pageObj.pageSize"
                        background
                        layout="prev, pager, next"
                        :total="pageObj.total"
                        @current-change="handleCurrentChange"
                    />
                </div>
            </div>
            <el-affix position="bottom" target=".resource-list" v-show="multiCheckList.length > 0">
                <div class="affix-wrapper">
                    <div class="multi-oper-wrapper" v-show="multiCheckList.length > 0">
                        <div class="multi-oper-con">
                            <div class="multi-check-con">
                                <el-checkbox
                                    class="srt-el-checkbox"
                                    v-model="isAllChecked"
                                    :indeterminate="isIndeterminate"
                                    @change="allCheckChange"
                                    >本页全选</el-checkbox
                                >
                            </div>
                            <div class="multi-btn-con">
                                <el-button
                                    v-if="
                                        multiDataType === 'resource' &&
                                        props.top.menuCode !== 'all-resource'
                                    "
                                    :disabled="multiCheckList.length > maxLen"
                                    class="multi-move-btn srt-el-button srt-el-button--link"
                                    type="primary"
                                    @click="btnClick('multi-move')"
                                    >移动到</el-button
                                >
                                <el-button
                                    type="primary"
                                    class="multi-remove-btn srt-el-button srt-el-button--primary"
                                    :disabled="multiCheckList.length > maxLen"
                                    @click="btnClick('multi-remove')"
                                >
                                    {{ `全部删除(${multiCheckList.length || 0})` }}</el-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </el-affix>
        </template>
        <template v-else>
            <div class="empty-container">
                <div class="empty-wrapper">
                    <img src="@/assets/img/resource/my-resource-empty.png" alt="" />
                    <p v-if="isSearch">没有找到符合的资源，换个条件试试吧</p>
                    <div v-else class="empty-not-search">
                        <p>暂无资源，您可以发布资源</p>
                    </div>
                </div>
            </div>
        </template>
        <PublishDialogVue
            v-model:visible="pushToTeacherSupportVisible"
            :id="activeResourceId"
        ></PublishDialogVue>
    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted, inject } from 'vue';
import Pagination from '@/components/pagination/pagination.vue';
import ellipsis from '@/components/ellipsis.vue';
import Dayjs from 'dayjs';
import { fileType } from '@/views/resource-issue/resource-issue.js';
import PublishDialogVue from './teacher-support-publish/index.vue';
import { useStore } from 'vuex';

const store = useStore();
const btnPermission = computed(() => store.state.user.btnPermission);
// props emits
const props = defineProps({
    data: {
        type: Array,
        default() {
            return [];
        },
    },
    page: {
        type: Object,
        default() {
            return {};
        },
    },
    top: {
        // 1.用于判断是否为协作组的数据 2.全部资源批量没有移动到按钮
        type: Object,
        default() {
            return {};
        },
    },
    multi: {
        type: Array,
        default() {
            return [];
        },
    },
    isSearch: {
        type: Boolean,
        default: false,
    },
});
const emit = defineEmits(['on-click', 'on-current-change', 'on-command', 'on-check']);
const hasWorkShop = inject('hasWorkShop');
const hasGroup = inject('hasGroup');
// data
const cateList = ref([
    { categoryCode: 'zyzx_jxyx', categoryName: '教学研修' },
    { categoryCode: 'zyzx_jyky', categoryName: '教育科研' },
    { categoryCode: 'zyzx_stsj', categoryName: '试题试卷' },
    { categoryCode: 'zyzx_dyxl', categoryName: '德育心理' },
    { categoryCode: 'zyzx_dxgx', categoryName: '党校干训' },
    { categoryCode: 'zyzx_other', categoryName: '其他资源' },
]); // 资源类型数据
const maxLen = 100; // 批量最大可选条数
const isAllChecked = ref(false); // 是否全选 翻页时 要判断当前页是否有选中项 有且不全的时候 显示半选中
const isIndeterminate = ref(false); // 是否未全选
const multiDataType = ref(''); // 多选数据的类型（folder：纯文件夹，resource：纯资源，mix：文件夹+
const multiCheckList = ref([]); // 存储多选数据
const folderBtnList = ref([
    // 列表中文件夹对应的操作按钮
    { label: '重命名', code: 'list-folder-rename' },
    { label: '移动', code: 'list-folder-move' },
    { label: '删除', code: 'list-folder-remove' },
]);
const resourceBtnList = ref([
    // 列表中资源文件对应的操作按钮
    {
        label: '社区公开',
        code: 'publish',
        show: status => {
            return status === '';
        },
    },
    {
        label: '取消公开',
        code: 'cancel-publish',
        show: status => {
            return status === 'approving';
        },
    },
    {
        label: '社区公开',
        code: 'republish',
        show: status => {
            return status === 'not_pass' || status === 'cancel' || status === 'community_removal';
        },
    },
    {
        label: '报送',
        code: 'resource-post',
        show: () => hasWorkShop || hasGroup,
    },
]);

const resourceMoreBtnList = computed(() => {
    const buttons = [
        // 列表中资源文件对应的更多下拉菜单
        {
            label: '编辑',
            code: 'resource-edit',
            show: data => {
                return data !== 'pass';
            },
        },
        // { label: '下载', code: 'download' },
        { label: '分享', code: 'share' },
        { label: '推送到其他网站', code: 'push' },
        { label: '移动到', code: 'move' },
        {
            label: '删除',
            code: 'remove',
            show: data => {
                return data !== 'pass';
            },
        },
    ];
    // 对需要授权的按钮进行授权
    if (!btnPermission.value.includes('siteFront:application:resource:push')) {
        return buttons.filter(item => item.code !== 'push');
    }
    return buttons;
});
const comName = inject('comName');

const scopeList = ref([
    { value: 'personal', label: '个人私有' },
    { value: 'group_open', label: comName + '公开' },
    { value: 'community_open', label: '社区公开' },
]);
const statusList = ref([
    { value: 'approving', label: '审核中' },
    { value: 'pass', label: '通过' },
    { value: 'not_pass', label: '未通过' },
    { value: 'community_removal', label: '已下架' },
    // { value: 'cancel', label: '撤销审核' }
]);

const explain = function (value, content) {
    const data = {
        not_pass: '经管理员审核，您的资源未通过，原因：',
        community_removal: '即该资源从广场下架,下架原因:',
    };

    return data[value] + content;
};
let resourceListRef = ref(null);

// computed watch
let resourceList = computed({
    get: () => props.data,
    set: val => {
        return val;
    },
});
let pageObj = computed({
    get: () => props.page,
    set: val => {
        return val;
    },
});

const pushToTeacherSupportVisible = ref(false);
const activeResourceId = ref();
watch(
    () => [props.data, props.page],
    ([curData, curPage]) => {
        let listData = [...curData];
        listData.forEach(i => {
            multiCheckList.value.forEach(j => {
                if (i.id === j.id) {
                    i.checked = true;
                }
            });
        });
        resourceList.value = listData;
        checkStatusRender();
        pageObj.value = curPage;
    },
    { deep: true },
);
watch(
    () => props.multi,
    cur => {
        multiCheckList.value = cur;
        let folderNum = 0;
        let resourceNum = 0;
        for (let i = 0; i < cur.length; i++) {
            if (cur[i].fileType === 0) {
                resourceNum++;
            } else if (cur[i].fileType === 1) {
                folderNum++;
            }
        }
        multiDataType.value =
            folderNum === cur.length ? 'folder' : resourceNum === cur.length ? 'resource' : 'mix';
    },
    { deep: true },
);

// methods
function dateFormate(date) {
    if (!date) {
        return '--';
    }
    return Dayjs(date).format('YYYY.MM.DD HH:mm:ss');
}

// methods
function fmtAuthors(data) {
    let list = data.map(item => {
        if (item.schoolName) {
            return item.userName + '-' + item.schoolName;
        }
        return item.userName;
    });
    return list.join('；') || '-';
}

function valueFormate(val, arr, valueFeild = 'value', labelFeild = 'label') {
    for (let i = 0; i < arr.length; i++) {
        if (arr[i][valueFeild] === val) {
            return arr[i][labelFeild];
        }
    }
}
function getCateTxt(cateTypeList = []) {
    if (!cateTypeList?.length) {
        return '--';
    }
    return cateTypeList.join('、');
    // if (!cateCode) {
    //     return '--';
    // }
    // let cateArr = cateCode.split(',');
    // let txtArr = [];
    // if (cateArr.length > 1) {
    //     cateArr.forEach(i => {
    //         txtArr.push(
    //             valueFormate(i, cateList.value, 'categoryCode', 'categoryName')
    //         );
    //     });
    //     return txtArr.join('、');
    // } else {
    //     return valueFormate(
    //         cateArr[0],
    //         cateList.value,
    //         'categoryCode',
    //         'categoryName'
    //     );
    // }
}

// 全选/全不选
function allCheckChange(val) {
    if (val) {
        resourceList.value.forEach(i => {
            i.checked = true;
        });
        multiCheckList.value = [...new Set([...multiCheckList.value, ...resourceList.value])];
    } else {
        resourceList.value.forEach(item => {
            item.checked = false;
            arrDelete(multiCheckList.value, i => {
                return i.id === item.id;
            });
        });
    }
    emit('on-check', multiCheckList.value);
    checkStatusRender();
}
// 每一项选中/取消选中
function listCheckChange(val, item) {
    item.checked = val;
    if (val) {
        multiCheckList.value.push(item);
    } else {
        arrDelete(multiCheckList.value, i => {
            return i.id === item.id;
        });
    }
    emit('on-check', multiCheckList.value);
    checkStatusRender();
}
// 数组删除指定对象
function arrDelete(arr, cb) {
    arr.forEach((i, idx) => {
        if (cb(i)) {
            arr.splice(idx, 1);
        }
    });
}
// 全选checkbox状态渲染
function checkStatusRender() {
    let checkedFileId = []; // 已选资源id集合
    let unCheckedFileId = []; // 未选资源id集合
    resourceList.value.forEach(i => {
        if (i.checked) {
            checkedFileId.push(i);
        } else {
            unCheckedFileId.push(i);
        }
    });
    // console.log('当前资源页的已选资源id集合：', checkedFileId);
    // console.log('当前资源页的未选资源id集合：', unCheckedFileId);
    isAllChecked.value = checkedFileId.length === resourceList.value.length;
    isIndeterminate.value =
        checkedFileId.length < resourceList.value.length && checkedFileId.length > 0;
}
// 资源名称、文件夹名称点击（资源点击跳转详情，文件夹点击获取下级文件夹、资源）
function resourceClick(data) {
    const emitData = {
        type: data.fileType === 0 ? 'detail' : 'folder-child',
        data,
    };
    emit('on-click', emitData);
}
// 资源列表按钮点击
function resourceItemClick(type, data, val) {
    emit('on-click', { type, data });
}
// 资源下拉按钮点击
function handleCommand(command, data) {
    // 推送到其他网站单独处理
    if (command === 'push') {
        pushToTeacherSupportVisible.value = true;
        activeResourceId.value = data.id;
    } else {
        emit('on-command', { command, data });
    }
}
// 资源翻页
function handleCurrentChange(val) {
    emit('on-current-change', val);
}
// 发布资源
function createresource() {
    emit('on-click', { type: 'create' });
}
// 批量按钮点击
function btnClick(type) {
    let multiIdList = [];
    multiCheckList.value.forEach(i => {
        multiIdList.push(i.id);
    });
    emit('on-click', {
        type,
        data: {
            type: multiDataType.value,
            data: multiIdList,
        },
    });
}
function getCateList() {
    G_transmit('getFilterCommunityAssetCategory', {
        name: 'getFilterCommunityAssetCategory',
        queries: {
            firstCategoryId: '',
            optionId: '',
            subCategoryId: '',
        },
    }).then(res => {
        cateList.value = res.data;
    });
}

onMounted(() => {
    getCateList();
});
</script>
<style lang="scss" scoped>
.folder-popover-list {
    max-height: 310px;
    overflow-y: auto;
    li {
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        margin: 3px 0;
        color: var(--color-black);
        cursor: pointer;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &:hover {
            background: var(--color-blue-auxiliary1);
            border-radius: 4px;
        }
    }
}
.resource-list {
    min-height: 410px;
    height: calc(100% - 136px);
    background: #fff;
    border-radius: 4px;
    .affix-wrapper {
        height: 60px;
        width: calc(50vw + 115px);
    }
    .multi-oper-wrapper {
        box-sizing: border-box;
        height: 60px;
        padding-left: 20px;
        box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.05);
        display: flex;
        align-items: center;
        background: #fff;
        .multi-oper-con {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 696px;
            height: 100%;
            .multi-check-con {
                display: flex;
                min-width: 190px;
                justify-content: space-between;
                align-items: center;
                font-size: 14px;
            }
            .checked-num {
                margin: 0 5px;
                color: #0257ff;
            }
            .multi-btn-con {
                height: 100%;
                display: flex;
                justify-content: flex-end;
                align-items: center;
            }
            .multi-move-btn {
                margin-right: 32px;
                font-size: 14px;
            }
            .multi-remove-btn {
                width: 120px;
                height: 100%;
                border-radius: 0;
                margin-left: 0;
                font-size: 14px;
            }
        }
    }
    .resource-list-wrapper {
        height: calc(100% - 60px);
        padding: 0 20px 20px;
    }
    .list-item {
        border-radius: 4px;
        border-bottom: 1px solid var(--color-gray-auxiliary2);
        padding: 14px 10px;
        line-height: 20px;
    }
    .list-item-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 6px;
        font-size: 14px;
        &.folder-item-top {
            margin-bottom: 0;
        }
        .check-icon-name {
            display: flex;
            align-items: center;
            width: 100%;
        }
        .list-checkbox {
            margin-right: 12px;
        }
        .resource-font-icon {
            font-size: 18px;
            margin-right: 6px;
        }
        .resource-icon {
            width: 18px;
            height: 18px;
            margin-right: 4px;
        }
        .resource-name {
            cursor: pointer;
            &:hover {
                color: #0084f6;
            }
        }
    }
    .list-item-bottom {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        width: 100%;
        font-size: 14px;
        color: var(--color-gray);
    }
    .resource-date-creator {
        display: flex;
        align-items: center;
        // width: calc(100% - 230px);
        flex-wrap: wrap;
        margin-left: 48px;
        color: var(--color-gray);
        &.resource-date-creator-group {
            margin-left: 22px;
        }
        .resource-divider {
            width: 1px;
            height: 14px;
            background: #b0b0b0;
            margin: 0 12px;
        }
        p {
            margin-right: 20px;
            margin-bottom: 6px;
            &.w146 {
                width: 146px;
            }
            &.w140 {
                width: 140px;
            }
            &.w166 {
                width: 166px;
            }
            &.w276 {
                width: 276px;
                margin-right: 0;
            }
        }
    }
}
.approve-msg {
    margin-left: 4px;
    color: var(--color-gray-auxiliary1);
    font-size: 14px;
    cursor: pointer;
}
.ownerName {
    cursor: pointer;
    &:hover {
        color: #0084f6;
    }
}
.text-overflow {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.resource-btn-con {
    max-width: 180px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    :deep(.el-button) {
        margin-right: 16px;
        margin-left: 0;
    }
}
.resource-more-btn {
    cursor: pointer;
    padding: 6px 0;
    color: var(--color-gray);
    &:hover {
        color: #0084f6;
    }
}
.empty-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 110px;

    .empty-wrapper {
        width: 260px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }

    .empty-not-search {
        width: 240px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
    }
    img {
        display: block;
        width: 240px;
        height: 160px;
    }
    p {
        line-height: 26px;
        color: var(--color-gray);
        font-size: 14px;
        margin-bottom: 15px;
    }
    .create-btn {
        width: 86px;
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
    }
}
.page-con {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 30px;
}
:deep(.el-affix--fixed) {
    left: calc(50vw - 121px);
}
.check-icon-name {
    :deep(.el-checkbox) {
        height: auto;
    }
}
</style>
<style lang="scss">
.msg-popover {
    width: auto !important;
    max-width: 380px;
    padding: 20px !important;
    font-size: 14px;
    color: var(--color-gray) !important;
    line-height: 22px !important;
    box-shadow: 0px 4px 16px 0px rgba(11, 23, 73, 0.1) !important;
    border: 0 !important;
}
</style>
